export default "__VITE_ASSET__CnWYiTOb__";